import styled from 'styled-components';
import { OfferStyled } from '../OfferStyled';

export const OfferStyledAC = styled(OfferStyled)`
    width: 100%;

    .offer {
        justify-content: space-between;

        .info-icon-container {
            &:focus-visible {
                outline: 3px solid ${({ theme }) => theme.colors.focus} !important;
            }
        }

        svg {
            circle {
                fill: ${({ theme }) => theme.colors.grey2};
                stroke: ${({ theme }) => theme.colors.grey2};
                stroke-width: 1px;
            }

            line {
                stroke: ${({ theme }) => theme.colors.white};
            }
        }
    }
`;
